import React from 'react'
import Radio from 'meinian-package/src/baseComponent/radio'
import './index.less'
import classNames from 'classnames'

export default ({ option, value, onChange, line = 3, wrapperStyle }) => {
  return <div className="mn-public-expand-select" style={wrapperStyle}>
    <div style={{ maxHeight: line * 32 + 10 }} className="mn-public-expand-select-scroll">
      {option?.map(item => <div className={classNames('mn-public-expand-select-item', 'df-center-space-between', { active: value === item.value })} onClick={() => onChange(item, item.value)}>
        <div>{item.label}</div>
        <Radio checked={value === item.value} />
      </div>)}
    </div>
  </div>
}
